
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({})
export default class Color extends Base {
  public textColor = "#FD8C99";
  public backgroundColor = "#FFED54";
}
